import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import classes from './LandingPage.css';
import SchneiderTopBar from '../../components/UI/SchneiderTopBar/SchneiderTopBar';
import LandingMenu from '../../components/LandingMenu/LandingMenu';
import LocalizedStrings from '../../assets/data/LocalizedStrings/LocalizedStrings.json';
import product from '../../assets/images/xfmr.jpg' // relative path to transformer image 
import SideBar from '../../components/UI/SideBar/SideBar';

// Set the paragraph style to center text.
const stylep = {
    textAlign: "center",
    fontFamily: "arial, sans-serif",
    fontSize: "1.2em",
    width: "70%",
    marginLeft: "auto",
    marginRight: "auto",
    listStyle: "none"
};

// Set the UL style to better center text.
const styleUL = {
    paddingLeft: "0px",
    marginTop: "30px"
};

// Set the paragraph style to center text.
const styleit = {
    textDecoration: "none",
    color: "#42b4e6",
    marginLeft: "-20px",
};


class LandingPage extends Component {
  state = {
    sideMenuTriggered: false
  };

  handleSideBarTrigger = () => {
    this.setState({
      sideMenuTriggered: true
    });
  };

  handleSideBarClose = () => {
    this.setState({
      sideMenuTriggered: false
    });
  };

  render() {
    const {
      language,
      country,
      selectedCanadaEN,
      selectedCanadaFR,
      selectedUSA
    } = this.props;

// Set the condition for a USA view.
if (country === 'USA') {
    var link = LocalizedStrings[language].landingPageLinkUS;
} 
    // Set for Canada and English. 
    else if (country === 'Canada' && language === 'en') { 
       var link = LocalizedStrings[language].landingPageLinkCA;
}
    // Default to Canada and French.
    else {
        var link = LocalizedStrings['fr'].landingPageLinkFR;
    }

    return (
      <Fragment>
        <div className={classes.LandingPage}>
          <SchneiderTopBar
            country={country}
            sideMenuTriggered={this.state.sideMenuTriggered}
            sideMenuHandler={this.handleSideBarTrigger}
          />
          <LandingMenu 
            language={language} 
            country={country} 
          />
        <ul style={styleUL}>
            <li style={stylep}><a style={styleit} href={link} target="_blank">{LocalizedStrings[language].landingPageLinkText}</a></li>
            <li style={stylep}><a style={styleit} href={link} target="_blank"><img src={product} alt={"Transformer"}/></a></li>
        </ul>
        </div>
        <SideBar
          opened={this.state.sideMenuTriggered}
          closeSideBar={this.handleSideBarClose}
          selectedCanadaEN={selectedCanadaEN}
          selectedCanadaFR={selectedCanadaFR}
          selectedUSA={selectedUSA}
          language={language}
          country={country}
        />
      </Fragment>
    );

  } //Close Render
} //Close Class

LandingPage.propTypes = {
  language: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  selectedCanadaEN: PropTypes.func,
  selectedCanadaFR: PropTypes.func,
  selectedUSA: PropTypes.func
};

export default withRouter(LandingPage);